module.exports = __webpack_public_path__ + "e882383568d7e08f3dd7f7a57dc01f37.svg";